import type { FC } from 'react';
import SchemaOrg from '@/components/base/SchemaOrg';
import HeroSection from './components/HeroSection';
import FeatureSection from './components/FeatureSection';
import CategorySection from './components/CategorySection';
import ArticleSection from './components/ArticleSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

const Home: FC = () => {
  return (
    <>
      <SchemaOrg
        type="WebSite"
        data={{
          name: '17c.com 官方入口',
          url: 'https://www.17c.com/',
          description: '17c.com 官方入口为您提供完整的平台介绍、核心功能解析、使用指南及常见问题解答',
          inLanguage: 'zh-Hans',
        }}
      />
      <SchemaOrg
        type="Organization"
        data={{
          name: '17c.com',
          url: 'https://www.17c.com/',
          description: '连接智慧，赋能未来 — 一站式数字化服务平台',
        }}
      />
      <main>
        <HeroSection />
        <FeatureSection />
        <CategorySection />
        <ArticleSection />
        <FAQSection />
        <CTASection />
      </main>
    </>
  );
};

export default Home;